export default function TrustBadges() {
  const badges = [
    {
      icon: 'ri-shield-check-line',
      title: 'Premium Quality',
      description: 'Carefully crafted with attention to every detail'
    },
    {
      icon: 'ri-t-shirt-line',
      title: 'Comfort First',
      description: 'Designed for all-day wear without compromise'
    },
    {
      icon: 'ri-star-line',
      title: 'Statement Piece',
      description: 'Stand out and represent the culture'
    }
  ];

  return (
    <div className="grid md:grid-cols-3 gap-6">
      {badges.map((badge, index) => (
        <div
          key={index}
          className="flex flex-col items-center text-center p-6 bg-white/5 rounded-lg border border-white/10"
        >
          <div className="w-16 h-16 flex items-center justify-center bg-white/10 rounded-full mb-4">
            <i className={`${badge.icon} text-3xl text-white`}></i>
          </div>
          <h3 className="text-white font-bold mb-2">{badge.title}</h3>
          <p className="text-white/60 text-sm">{badge.description}</p>
        </div>
      ))}
    </div>
  );
}